import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Col, message, Popconfirm, Row } from "antd";
import { ColumnsType } from "antd/lib/table";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import thongTinKhoaHocApi from "../../../../api/thongTinKhoaHoc";
import { Duplicate } from "../../../../assets/icon/duplicate";
import TableWrap from "../../../../components/Table";
import TopContent from "../../../../components/TopContent";
import PageWrap from "../../../../layout/PageWrap";
import { appRoutes } from "../../../../routes/routes";
import { messages } from "../../../../utils/messages";
import Ratings from "../../../Library/Indicator/ListIndicators/Ratings";

const ListDanhGiaKhoaHoc = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const { data, isLoading, isFetching }: any = useQuery(
    ["training_danh_gia_khoa_hoc"],
    thongTinKhoaHocApi.getListDanhGia
  );
  const mutation = useMutation(thongTinKhoaHocApi.deletePhanHoi, {
    onSuccess: (data: any) => {
      if (data.statusCode === 200) {
        message.success(messages.deleteSuccess);
        queryClient.invalidateQueries(["training_danh_gia_khoa_hoc"]);
      }
    },
    onError: (err: any) => {
      message.error(messages.error);
    },
  });
  const update = useMutation(thongTinKhoaHocApi.editPhanHoi, {
    onSuccess: (data: any) => {
      if (data.statusCode === 200) {
        message.success(messages.updateSuccess);
        queryClient.invalidateQueries(["training_danh_gia_khoa_hoc"]);
      } else {
        message.error(data?.data?.message ?? messages.error);
      }
    },
    onError: (err: any) => {
      message.error(err?.data?.message ?? messages.error);
    },
  });

  const columns: ColumnsType<any> = [
    {
      title: "STT",
      align: "center",
      width: "5%",
      dataIndex: "stt",
      key: "stt",
    },
    {
      title: "Chuyên mục",
      dataIndex: "danh_muc",
      key: "danh_muc",
    },
    {
      title: "Người đánh giá",
      dataIndex: "name",
      key: "name",
      width: "20%",
    },
    {
      title: "Nội dung đánh giá",
      dataIndex: "noidung",
      key: "noidung",
    },
    {
      title: "Rating",
      dataIndex: "star",
      key: "star",
      width: "15%",
      render: (record: any, dt: any) => (
        <Ratings defaultStar={record - 1} id={dt._id} event={false} />
      ),
    },
    {
      title: "Sửa",
      align: "center",
      width: "4%",
      render: (_, record: any) => {
        return (
          <EditOutlined
            onClick={() =>
              navigate(`${appRoutes.TRAINING.DANH_GIA_KHOA_HOC.LIST}/${record?._id}`)
            }
          />
        );
      },
    },
    {
      title: "Xóa",
      align: "center",
      width: "4%",
      render: (_, record: any) => {
        return (
          <Popconfirm
            title="Xác nhận xóa đánh giá này"
            style={{ width: "100px" }}
            onConfirm={(e: any) => {
              e.preventDefault();
              mutation.mutate(record._id);
            }}
          >
            <DeleteOutlined style={{ color: "red" }} />
          </Popconfirm>
        );
      },
    },
  ];

  return (
    <PageWrap
      title="Đánh giá khóa học"
      content={
        <>
          <TopContent
            content={
              <Row>
                <Col>
                  <b>Đánh giá khóa học</b>
                </Col>
                <Col>
                  <Button
                    onClick={() =>
                      navigate(`${appRoutes.TRAINING.DANH_GIA_KHOA_HOC.ADD}`)
                    }
                  >
                    <PlusOutlined /> Add
                  </Button>
                </Col>
              </Row>
            }
          />
          <div className="content">
            <TableWrap
              loading={isLoading || isFetching}
              columns={columns}
              isShowTotal
              dataSource={data?.data}
              rowKey="_id"
              bordered
              pagination={false}
              className="hover table-slide"
              hasDefaultColumn={false}
            />
          </div>
        </>
      }
    />
  );
};

export default ListDanhGiaKhoaHoc;
